export default __webpack_public_path__ + "static/media/Cisla.14ae4bc6.png";